module.exports = __webpack_public_path__ + "static/software_development_icon-2ebf65324e0b9aea01811ef436b7b977.png";